<template>
  <div class="m-levels">
      <div class="m-level__wrap"  :key="level.level" v-for="level in getAllLevels">
        <router-link v-if="getLevel === level.level" v-bind:class="
        'm-level__' + level.level" class="m-level" :to="{ name: 'levelIntro'}">
          <span class="m-level__number" v-bind:class="'m-level__number--' + level.level">
            {{ level.level }}
          </span>
        </router-link>
        <span v-else v-bind:class="
        [ getLevel != level.level ? 'm-level--inactive' : '',
        getLevel > level.level ? 'm-level--completed' : '',
        'm-level__' + level.level,
        ]" class="m-level" :to="{ name: 'levelIntro'}">
          <span class="m-level__number" v-bind:class="'m-level__number--' + level.level">
              {{ level.level }}
            </span>
        </span>
        <span v-if="level.level < getAllLevels.length" class="m-level__bar"
         v-bind:class="[
          getLevel != level.level ? 'm-level__bar--inactive' : '',
          getLevel > level.level ? 'm-level__bar--completed' : '',
         'm-level__bar--' + level.level]"></span>
      </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['getLevel', 'getAllLevels']),
  },
  methods: {
    ...mapActions(['increaseLevel', 'setQuestionIndex', 'resetQuestionIndex']),
    goToQuestion(QId) {
      this.$router.push({ name: 'question', params: { id: QId } });
    },
    getFirstQuestion(level) {
      this.resetQuestionIndex();
      const questions = this.$store.state.questions.filter(question => question.level === level);
      const firstQuestion = questions[0].id;
      this.goToQuestion(firstQuestion);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ChooseLevel.vue